import MojitoCore from 'mojito/core';
import MeetingsViewImpl from './meetings-view.js';

const { UIView } = MojitoCore.Presentation;

/**
 * MeetingsView - renders meetings content inside SportPage.
 *
 * @class MeetingsView
 * @memberof Mojito.Applications.Sports.Pages
 */

export default UIView('MeetingsView', MeetingsViewImpl);
